import styled from 'styled-components'

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    justify-content: space-between;
  }
`

export const ShowHideButton = styled.button`
  position: absolute;
  right: 20px;
  top: calc(50% - 10px);
  transform: translateY(-50%);
  border: 0;
  background: none;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  line-height: 14px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.coolGray.cool600};
  cursor: pointer;
  transition: color 0.15s;
  &:focus {
    outline: none;
  }
  &:hover {
    color: ${({ theme }) => theme.colors.coolGray.cool900};
  }
`
